import React from 'react';

import GoogleAnalyticsScript from './GoogleAnalyticsScript';

const ThirdPartyScripts = () => <GoogleAnalyticsScript />;

export default ThirdPartyScripts;
